# Generated from app.intent.md — do not edit manually
# Route: /materials/lots/receive
# Audience: Operators (md+), blocked on sm
# Ref: app.intent.md § Receive Material

page-lot-receive:
  type: Page
  archetype: create
  meta:
    title: $t.lot_receive.meta_title
    auth: required
  data:
    definitions:
      model: ItemDefinition[]
      refresh: on_mount
    # F75 #139 (AC-P2) — controlled UoM vocabulary; the receive UoM select is
    # constrained to it and the API rejects any unit that doesn't match the
    # chosen definition's base unit.
    uom:
      model: UnitOfMeasure[]
      refresh: on_mount
    # F75 #140 (AC-P3) — pickable storage locations (id + label); the form
    # submits the location id, which the API resolves against the Location
    # aggregate.
    locations:
      model: LocationOption[]
      refresh: on_mount
  spatial:
    display: flex
    direction: column
    gap: $spacing.lg
    padding: $spacing.lg
    padding_inline: $spacing.xl
    overflow: auto
  tokens:
    background: $color_scheme.light.color.surface
  children:
    - receive-sm-notice
    - receive-content

# ── sm viewport notice ───────────────────────────────────────────────────────

receive-sm-notice:
  type: SmNotice
  content: $t.common.sm_notice_receive

# ── Main content (hidden on sm) ──────────────────────────────────────────────

receive-content:
  type: Section
  spatial:
    display: flex
    direction: column
    gap: $spacing.lg
    responsive:
      sm:
        display: none
  children:
    - receive-header
    - receive-form

# ── Header ───────────────────────────────────────────────────────────────────

receive-header:
  type: PageHeader
  content: $t.lot_receive.title
  back_route: /materials/lots

# ── Receive form ─────────────────────────────────────────────────────────────
#
# Defaults applied by the emitter (Form meta):
#   - single-column layout, max-width ~40rem (comfortable reading width)
#   - loading state fades inputs to 0.6 opacity during submission
#   - sticky FormActions on sm/md, inline on lg+
#
# Input meta applies:
#   - touch-safe min_height
#   - a focus outline, from InputCssGenerator.cs:96-99 (`input:focus,
#     textarea:focus, select:focus`) — it keys on :focus rather than
#     :focus-visible, so it also shows on mouse click. The :host(:focus-visible)
#     rule FocusCssGenerator writes does NOT render; see
#     design-system/accessibility.md § Focus visible ring. There is also no
#     `focus_visible` states key — the state name `states:` knows is `focus`,
#     and a `focus` block cannot emit an outline anyway.
#   - required indicator + validation timing
# Authors should not spell these out per field.

receive-form:
  type: Form
  model: ReceiveMaterialForm
  a11y:
    label: $t.lot_receive.form_label
  action:
    type: create
    model: ItemLot
    endpoint: /api/items/lots/receive
    on_success: navigate(/materials/lots)
  spatial:
    display: flex
    direction: column
    gap: $spacing.md
  children:
    - receive-field-lot-number
    - receive-field-material-def
    - receive-qty-row
    - receive-field-storage
    - receive-field-expiry
    - receive-field-received-from
    - receive-form-actions

receive-field-lot-number:
  type: Input
  input_type: text
  label: $t.lot_receive.field_lot_number
  bind: form.lotNumber
  required: true
  a11y:
    label: $t.lot_receive.field_lot_number

# Material definition is a controlled select over the definitions list
# (same picker shape as the UoM + storage selects below); the submitted
# value is the definition id.
receive-field-material-def:
  type: Input
  input_type: select
  label: $t.lot_receive.field_material_def
  bind:
    value: form.itemDefinitionId
    options: definitions
  required: true
  a11y:
    label: $t.lot_receive.field_material_def

receive-qty-row:
  type: Section
  spatial:
    display: flex
    gap: $spacing.md
  children:
    - receive-field-qty-value
    - receive-field-qty-unit

receive-field-qty-value:
  type: Input
  input_type: number
  label: $t.lot_receive.field_qty_value
  bind: form.quantity.value
  required: true
  a11y:
    label: $t.lot_receive.field_qty_value_label

# F75 #139 (AC-P2) — the receive API accepts ONLY the chosen definition's
# base unit (ReceiveItemHandler rejects any other unit with a 4xx), so the
# ideal UX is a unit field that auto-follows the material-definition select.
# CIR cannot express that yet: Input has no disabled/readonly/default
# property and no derived/computed/on_change mechanism (XP85 computed fields
# are Phase-4 scope, unimplemented) — emitter follow-up required. Until
# then the select stays over the controlled vocabulary (no free typing) and
# the helper text steers the operator to the definition's base unit.
receive-field-qty-unit:
  type: Input
  input_type: select
  label: $t.lot_receive.field_qty_unit
  bind:
    value: form.quantity.unitOfMeasure
    options: uom
  required: true
  helper: $t.lot_receive.field_qty_unit_helper
  spatial:
    max_width: 12rem
  a11y:
    label: $t.lot_receive.field_qty_unit_label

# F75 #140 (AC-P3) — storage location is a picker over real Location ids
# (same controlled-vocab select shape as the UoM field); the submitted value
# is the location id and unknown ids are rejected by the receive API.
receive-field-storage:
  type: Input
  input_type: select
  label: $t.lot_receive.field_storage
  bind:
    value: form.storageLocationId
    options: locations
  a11y:
    label: $t.lot_receive.field_storage_label

receive-field-expiry:
  type: Input
  input_type: date
  label: $t.lot_receive.field_expiry
  bind: form.expiryDate
  spatial:
    max_width: 12rem
  a11y:
    label: $t.lot_receive.field_expiry_label

receive-field-received-from:
  type: Input
  input_type: text
  label: $t.lot_receive.field_received_from
  bind: form.receivedFrom
  a11y:
    label: $t.lot_receive.field_received_from_label

# FormActions meta applies sticky-bottom default on sm/md, inline on lg+.
# submit_label + cancel_route is the canonical shorthand for Submit/Cancel pairs.

receive-form-actions:
  type: FormActions
  submit_label: $t.lot_receive.btn_submit
  cancel_route: /materials/lots
